// import classNames from 'classnames';
import cn from 'classnames';
import DotsLoading from 'components/loadings/dotsLoading';

interface ICustomButtonType {
  title: string;
  disabled: boolean;
  classname?: string;
  isLoading?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}
const CustomButton = ({
  title,
  disabled,
  classname,
  isLoading,
  type,
}: ICustomButtonType) => {
  return (
    <>
      <button
        disabled={disabled}
        type={type}
        className={cn(
          'w-full rounded-lg text-white  py-2',
          disabled ? ' bg-gray-500' : 'bg-cyan-2',
          classname,
        )}
      >
        {isLoading ? <DotsLoading /> : title}
      </button>
    </>
  );
};

export default CustomButton;
